var map = {
	"./badge.png": 27894,
	"./badgeWithText.png": 67131,
	"./categories/sponsors/celsys.png": 733,
	"./categories/sponsors/huion.png": 55925,
	"./categories/sponsors/marmoset.png": 25502,
	"./categories/sponsors/paintable.png": 65808,
	"./categories/sponsors/pencilkings.png": 20757,
	"./categories/sponsors/tonytextures.png": 2482,
	"./judges/kirill_tokarev.png": 7648,
	"./judges/samur_isma.png": 83217,
	"./judges/stephen_price.png": 47387,
	"./partners/bleank.png": 44770,
	"./partners/boris_fx.png": 80705,
	"./partners/celsys.png": 58832,
	"./partners/escape_motions.png": 57326,
	"./partners/fanurio_time_tracking.png": 74733,
	"./partners/huion.png": 12410,
	"./partners/lightwell.png": 80271,
	"./partners/marmoset.png": 46371,
	"./partners/media/80level.png": 50264,
	"./partners/media/andy_sowards.png": 82654,
	"./partners/media/concept_art_world.png": 58661,
	"./partners/media/freeyork.png": 57199,
	"./partners/nevercenter.png": 84894,
	"./partners/paintable.png": 5151,
	"./partners/pencilkings.png": 40246,
	"./partners/stash_magazine.png": 7295,
	"./partners/tonytextures.png": 70471
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54985;